export enum Errors {
    DP_REST = "We're sorry, it looks like we're having trouble connecting to your practices. Make sure that all of your practices are online.",
}
